// Vendors
import styled from 'styled-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const FinancialDataDetailComponentStyled = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing_250};
  text-align: center;
  width: 100%;
`;
FinancialDataDetailComponentStyled.displayName = 'FinancialDataDetailComponentStyled';

const FinancialDataContainerStyled = styled.div`
  display: flex;
  height: ${convertPxsToRems({ pixels: 24, base: 16 })};
  align-items: center;
  gap: ${FoundationsCobrandedRegularTheme.spacing_300};
  align-self: stretch;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.onlyMobile} {
    gap: ${FoundationsCobrandedRegularTheme.spacing_150};
  }
`;

FinancialDataContainerStyled.displayName = 'FinancialDataContainerStyled';

const FinancialDataNameStyled = styled.span`
  display: flex;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  font-size: ${FoundationsCobrandedRegularTheme.font_size_paragraph_small};
  font-weight: ${FoundationsCobrandedRegularTheme.font_weight_paragraph_small_regular};
  line-height: ${FoundationsCobrandedRegularTheme.font_line_height_paragraph_small};
`;

FinancialDataNameStyled.displayName = 'FinancialDataNameStyled';

const FinancialDataQuantityStyled = styled.span`
  text-align: right;
  font-size: ${FoundationsCobrandedRegularTheme.font_size_paragraph_medium};
`;

FinancialDataQuantityStyled.displayName = 'FinancialDataQuantityStyled';

export {
  FinancialDataDetailComponentStyled,
  FinancialDataContainerStyled,
  FinancialDataNameStyled,
  FinancialDataQuantityStyled,
};
